export enum BankAccountType {
  TYPE_CHECKING = 1,
  TYPE_SAVING = 2,
}

export enum DocumentType {
  CNPJ = 1,
  CPF = 2,
}
